(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custm-article"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var toggle = document.querySelector('.custm-article__toc-toggle');
    if (toggle) {
      toggle.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    }

    var tocList = document.getElementById('custm-article-toc-list');
    if (!tocList) return;

    var content = document.querySelector('.custm-article__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocList.closest('.custm-article__toc').style.display = 'none';
      return;
    }

    headings.forEach(function(heading, index) {
      var id = heading.id || 'section-' + (index + 1);
      heading.id = id;

      var li = document.createElement('li');
      if (heading.tagName === 'H3') {
        li.className = 'custm-article__toc-item--h3';
      }

      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custm-faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion {
    constructor() {
      this.items = document.querySelectorAll('[data-faq-item]');
      this.init();
    }

    init() {
      this.items.forEach(item => {
        const button = item.querySelector('[data-faq-button]');
        const answer = item.querySelector('[data-faq-answer]');

        if (button && answer) {
          button.addEventListener('click', () => this.toggle(item, button, answer));
        }
      });
    }

    toggle(item, button, answer) {
      const isExpanded = item.getAttribute('data-expanded') === 'true';

      if (isExpanded) {
        this.collapse(item, button, answer);
      } else {
        this.expand(item, button, answer);
      }
    }

    expand(item, button, answer) {
      item.setAttribute('data-expanded', 'true');
      button.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    collapse(item, button, answer) {
      item.setAttribute('data-expanded', 'false');
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0';
    }
  }

  // Initialize FAQ accordion when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new FaqAccordion());
  } else {
    new FaqAccordion();
  }

  // Reinitialize when section is loaded in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-faq-item]')) {
      new FaqAccordion();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custm-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  class WelcomePopup extends HTMLElement {
    constructor() {
      super();
      this.STORAGE_KEY = 'papaya_welcome_popup';
      this.expiryKey = 'papaya_discount_expiry';
      this.delayMs = (parseInt(this.getAttribute('data-delay'), 10) || 10) * 1000;
      this.reshowDays = parseInt(this.getAttribute('data-reshow-days'), 10) || 7;
      this.expirationHours = parseInt(this.getAttribute('data-expiration-hours'), 10) || 72;
      this.timer = null;
      this.countdownInterval = null;
    }
    connectedCallback() {
      // After form submission, Shopify reloads the page.
      // Liquid injects a hidden marker so JS knows the result.
      const formResult = this.querySelector('[data-form-result]');
      if (formResult) {
        const result = formResult.getAttribute('data-form-result');
        if (result === 'success') {
          this.saveState('submitted');
          localStorage.setItem(this.expiryKey, Date.now() + this.expirationHours * 3600000);
          this.show();
          this.goToStep(3);
          this._populateSuccessEmail();
          return;
        }
        if (result === 'error') {
          this.show();
          this.goToStep(2);
          return;
        }
      }
      if (window.Shopify && window.Shopify.designMode) {
        this.show();
        return;
      }
      const state = this.getState();
      if (state === 'submitted') return;
      if (state === 'dismissed') {
        this.showFab();
        return;
      }
      if (state === 'expired' || state === 'new') {
        this.timer = setTimeout(() => this.show(), this.delayMs);
      }
    }
    disconnectedCallback() {
      if (this.timer) clearTimeout(this.timer);
      this.cleanup();
    }
    getState() {
      try {
        const data = JSON.parse(localStorage.getItem(this.STORAGE_KEY));
        if (!data) return 'new';
        if (data.submitted) return 'submitted';
        if (data.dismissed) {
          const dismissedAt = new Date(data.dismissedAt);
          const daysSince = (Date.now() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);
          return daysSince >= this.reshowDays ? 'expired' : 'dismissed';
        }
        return 'new';
      } catch (e) {
        return 'new';
      }
    }
    show() {
      this.removeAttribute('hidden');
      requestAnimationFrame(() => {
        this.setAttribute('open', '');
      });
      document.body.classList.add('overflow-hidden');
      this.bindEvents();
      trapFocus(this);
    }
    goToStep(n) {
      this.querySelectorAll('[data-popup-step]').forEach(step => {
        step.classList.remove('welcome-popup__step--active');
      });
      const target = this.querySelector(`[data-popup-step="${n}"]`);
      if (target) {
        target.classList.add('welcome-popup__step--active');
        const focusTarget = target.querySelector('button, input, [tabindex]');
        if (focusTarget) focusTarget.focus();
      }
      if (n === 3) {
        this.startCountdown();
      }
    }
    _populateSuccessEmail() {
      try {
        const email = localStorage.getItem('papaya_popup_email');
        if (email) {
          const checkoutBtn = this.querySelector('[data-checkout-btn]');
          if (checkoutBtn) {
            const url = new URL(checkoutBtn.href);
            url.searchParams.set('checkout[email]', email);
            checkoutBtn.href = url.toString();
          }
        }
      } catch (e) {}
    }
    startCountdown() {
      const expiry = parseInt(localStorage.getItem(this.expiryKey));
      if (!expiry) return;
      const updateTimer = () => {
        const now = Date.now();
        const diff = expiry - now;
        if (diff <= 0) {
          const timerEl = this.querySelector('.welcome-popup__timer');
          if (timerEl) timerEl.textContent = 'Expired';
          if (this.countdownInterval) clearInterval(this.countdownInterval);
          return;
        }
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        const daysEl = this.querySelector('[data-timer-days]');
        const hoursEl = this.querySelector('[data-timer-hours]');
        const minutesEl = this.querySelector('[data-timer-minutes]');
        const secondsEl = this.querySelector('[data-timer-seconds]');
        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = hours;
        if (minutesEl) minutesEl.textContent = minutes;
        if (secondsEl) secondsEl.textContent = seconds;
      };
      updateTimer();
      this.countdownInterval = setInterval(updateTimer, 1000);
    }
    close(reason) {
      if (reason === 'dismissed') {
        this.minimize();
        return;
      }
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      const fab = this.querySelector('[data-popup-fab]');
      if (fab) fab.setAttribute('hidden', '');
      const onEnd = () => {
        this.setAttribute('hidden', '');
        this.removeEventListener('transitionend', onEnd);
      };
      this.addEventListener('transitionend', onEnd);
      removeTrapFocus();
      this.saveState(reason);
      this.cleanup();
    }
    minimize() {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus();
      this.cleanup();
      this.saveState('dismissed');
      const card = this.querySelector('.welcome-popup__card');
      const overlay = this.querySelector('[data-popup-overlay]');
      // Fade out overlay
      if (overlay) overlay.style.opacity = '0';
      // Animate card shrinking toward bottom-right
      card.classList.add('welcome-popup__card--minimizing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        card.removeEventListener('transitionend', finish);
        card.classList.remove('welcome-popup__card--minimizing');
        this.removeAttribute('open');
        if (card) card.style.display = 'none';
        if (overlay) {
          overlay.style.display = 'none';
          overlay.style.opacity = '';
        }
        this.showFab();
      };
      card.addEventListener('transitionend', finish);
      // Fallback if transitionend doesn't fire
      setTimeout(finish, 600);
    }
    showFab() {
      this.removeAttribute('hidden');
      const fab = this.querySelector('[data-popup-fab]');
      if (!fab) return;
      fab.removeAttribute('hidden');
      if (!this._onFabClick) {
        this._onFabClick = () => this.openFromFab();
        fab.addEventListener('click', this._onFabClick);
      }
    }
    openFromFab() {
      const fab = this.querySelector('[data-popup-fab]');
      if (fab) fab.setAttribute('hidden', '');
      const card = this.querySelector('.welcome-popup__card');
      const overlay = this.querySelector('[data-popup-overlay]');
      if (card) card.style.display = '';
      if (overlay) {
        overlay.style.display = '';
        overlay.style.opacity = '';
      }
      this.goToStep(1);
      this.show();
    }
    saveState(reason) {
      try {
        if (reason === 'submitted') {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ submitted: true }));
        } else if (reason === 'dismissed') {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ dismissed: true, dismissedAt: new Date().toISOString() }));
        }
      } catch (e) {
        // localStorage unavailable — silently fail
      }
    }
    closeAndShowCheckoutFab() {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus();
      this.cleanup();
      this.saveState('submitted');
      const card = this.querySelector('.welcome-popup__card');
      const overlay = this.querySelector('[data-popup-overlay]');
      const checkoutBtn = this.querySelector('[data-checkout-btn]');
      const checkoutUrl = checkoutBtn ? checkoutBtn.href : null;
      if (overlay) overlay.style.opacity = '0';
      card.classList.add('welcome-popup__card--minimizing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        card.removeEventListener('transitionend', finish);
        card.classList.remove('welcome-popup__card--minimizing');
        this.removeAttribute('open');
        if (card) card.style.display = 'none';
        if (overlay) {
          overlay.style.display = 'none';
          overlay.style.opacity = '';
        }
        this.showCheckoutFab(checkoutUrl);
      };
      card.addEventListener('transitionend', finish);
      setTimeout(finish, 600);
    }
    showCheckoutFab(url) {
      this.removeAttribute('hidden');
      const fab = this.querySelector('[data-popup-fab]');
      if (!fab) return;
      fab.removeAttribute('hidden');
      fab.classList.add('welcome-popup__fab--checkout');
      const fabText = fab.getAttribute('data-fab-checkout-text') || 'Check out now with discount';
      fab.setAttribute('aria-label', fabText);
      const textEl = fab.querySelector('.welcome-popup__fab-text');
      if (textEl) textEl.textContent = fabText;
      if (!this._onFabClick) {
        this._onFabClick = () => {
          if (url) window.location.href = url;
        };
        fab.addEventListener('click', this._onFabClick);
      }
    }
    bindEvents() {
      this._onYes = () => this.goToStep(2);
      this._onNo = () => this.close('dismissed');
      this._onCloseClick = () => this.close('dismissed');
      this._onOverlayClick = () => this.close('dismissed');
      this._onKeydown = (e) => {
        if (e.key === 'Escape') this.close('dismissed');
      };
      const form = this.querySelector('#welcome-popup-form');
      if (form) {
        this._onFormSubmit = () => {
          try {
            const emailInput = form.querySelector('[name="contact[email]"]');
            if (emailInput) localStorage.setItem('papaya_popup_email', emailInput.value);
          } catch (e) {}
        };
        form.addEventListener('submit', this._onFormSubmit);
      }
      this.querySelector('[data-popup-yes]').addEventListener('click', this._onYes);
      this.querySelector('[data-popup-no]').addEventListener('click', this._onNo);
      this.querySelectorAll('[data-popup-close]').forEach(btn => {
        btn.addEventListener('click', this._onCloseClick);
      });
      const closeSuccessBtn = this.querySelector('[data-popup-close-success]');
      if (closeSuccessBtn) {
        this._onCloseSuccess = () => this.closeAndShowCheckoutFab();
        closeSuccessBtn.addEventListener('click', this._onCloseSuccess);
      }
      this.querySelector('[data-popup-overlay]').addEventListener('click', this._onOverlayClick);
      document.addEventListener('keydown', this._onKeydown);

      const copyBtn = this.querySelector('[data-copy-btn]');
      if (copyBtn) {
        this._onCopyClick = () => {
          const codeEl = this.querySelector('.welcome-popup__code');
          if (codeEl) {
            navigator.clipboard.writeText(codeEl.textContent).then(() => {
              // Optional: Show a toast or change button text temporarily
              const originalSvg = copyBtn.innerHTML;
              copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
              setTimeout(() => {
                copyBtn.innerHTML = originalSvg;
              }, 2000);
            }).catch(err => {
              console.error('Failed to copy: ', err);
            });
          }
        };
        copyBtn.addEventListener('click', this._onCopyClick);
      }
    }
    cleanup() {
      if (this._onFormSubmit) {
        const form = this.querySelector('#welcome-popup-form');
        if (form) form.removeEventListener('submit', this._onFormSubmit);
      }
      if (this._onYes) {
        const yesBtn = this.querySelector('[data-popup-yes]');
        if (yesBtn) yesBtn.removeEventListener('click', this._onYes);
      }
      if (this._onNo) {
        const noBtn = this.querySelector('[data-popup-no]');
        if (noBtn) noBtn.removeEventListener('click', this._onNo);
      }
      if (this._onCloseClick) {
        this.querySelectorAll('[data-popup-close]').forEach(btn => {
          btn.removeEventListener('click', this._onCloseClick);
        });
      }
      if (this._onOverlayClick) {
        const overlay = this.querySelector('[data-popup-overlay]');
        if (overlay) overlay.removeEventListener('click', this._onOverlayClick);
      }
      if (this._onKeydown) {
        document.removeEventListener('keydown', this._onKeydown);
      }
      if (this._onCloseSuccess) {
        const btn = this.querySelector('[data-popup-close-success]');
        if (btn) btn.removeEventListener('click', this._onCloseSuccess);
      }
      if (this._onCopyClick) {
        const copyBtn = this.querySelector('[data-copy-btn]');
        if (copyBtn) copyBtn.removeEventListener('click', this._onCopyClick);
      }
      if (this.countdownInterval) clearInterval(this.countdownInterval);
    }
  }
  customElements.define('welcome-popup', WelcomePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
